<!-- eslint-disable vue/no-confusing-v-for-v-if -->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <main class="main main--has-floating-buttons">
    <card :title="$t('pageFindReservation.card.findReservation')" :cols="extendedOptions ? '12 8@tablet 9@desktop 10@hd' : '12'">
      <hm-card-inner>
        <hm-input v-model="search.name"
                  :lazy="false"
                  :label="$t('pageFindReservation.search_input')"
                  :help="$t('pageFindReservation.search_help')"
                  name="search"
                  cols="12 2@hd 2@desktop 6@tablet"
                  @blur="updateSearch()">
          <template slot="icon-inline-left" slot-scope="slot">
            <icon icon="search" />
          </template>
          <template slot="icon-inline-right" slot-scope="slot">
            <input-icon-button v-if="!isEmpty(search.name)" :border="false" icon="close-text" @click="search.name = null" />
          </template>
        </hm-input>
        <hm-input-date ref="startDate"
                       v-model="search.startDate"
                       :disabled="allReservations"
                       :max-date="maxHotelDate"
                       :label="$t('pageFindReservation.startDate')"
                       cols="12 2@hd 2@desktop 6@tablet"
                       name="startDate" />
        <hm-input-date ref="endDate"
                       v-model="search.endDate"
                       :disabled="allReservations"
                       :max-date="maxHotelDate"
                       :min-date="search.startDate"
                       :min-date-inclusive="true"
                       :max-days="-1"
                       :label="$t('pageFindReservation.endDate')"
                       cols="12 2@hd 2@desktop 6@tablet"
                       name="endDate" />
        <hm-input-select v-model="search.status"
                         :label="$t('pageFindReservation.status')"
                         :disabled="allReservations"
                         name="status"
                         cols="12 2@hd 2@desktop 6@tablet"
                         enum-name="ReservationStatus">
          <option :value="null"></option>
        </hm-input-select>
        <hm-input-select v-model="search.limit"
                         :label="$t('pageFindReservation.limit')"
                         class="hidden visible@desktop"
                         name="status"
                         cols="12 2@hd 2@desktop 6@tablet">
          <option :value="100">100</option>
          <option :value="250">250</option>
          <option :value="500">500</option>
          <option :value="1000">1000</option>
        </hm-input-select>
        <hm-input v-model="filter"
                  :lazy="false"
                  :label="$t('pageFindReservation.filter')"
                  name="filter"
                  cols="12 2@hd start-11@hd 2@desktop start-11@desktop 6@tablet start-7@tablet">
          <template slot="icon-inline-left" slot-scope="slot">
            <icon icon="filter" />
          </template>
          <template slot="icon-inline-right" slot-scope="slot">
            <input-icon-button v-if="!isEmpty(filter)" :border="false" icon="close-text" @click="filter = null" />
          </template>
        </hm-input>
        <hm-input-toggle v-model="arrivalsOnly"
                         :label="$t('pageFindReservation.arrivalsOnly')"
                         :disabled="allReservations"
                         name="arrivalsOnly"
                         cols="12 4@tablet 2@desktop 2@hd start-1"/>
        <hm-input-toggle v-model="departuresOnly"
                         :label="$t('pageFindReservation.departuresOnly')"
                         :disabled="allReservations"
                         name="departuresOnly"
                         cols="12 4@tablet 2@desktop 2@hd"/>
        <hm-input-toggle v-model="onRequestOnly"
                         :label="$t('pageFindReservation.onRequestOnly')"
                         :disabled="allReservations"
                         name="onRequestOnly"
                         cols="12 4@tablet 2@desktop 2@hd"/>
        <hm-input-toggle v-model="search.excludeOnRequest"
                         :label="$t('pageFindReservation.excludeOnRequest')"
                         :help="$t('pageFindReservation.excludeOnRequest_help')"
                         :disabled="allReservations"
                         name="excludeOnRequest"
                         cols="12 4@tablet 2@desktop 2@hd" />
        <hm-input-toggle v-model="allReservations" :label="$t('pageFindReservation.allReservations')" name="allReservations" cols="12 4@tablet 2@desktop 2@hd" />
        <hm-input-toggle v-model="extendedOptions"
                         :label="$t('pageFindReservation.extendedOptions')"
                         name="extendedOptions"
                         cols="12 4@tablet 2@desktop 2@hd"
                         class="hidden visible@desktop visible@hd"/>
        <span v-if="!isNil(lastSearch) && rows.length === lastSearch.limit" class="text-block text-block--small text-block--info col-12">{{ $t('pageFindReservation.infoMoreResults', { results: lastSearch.limit }) }}</span>
        <span v-else-if="rows.length > 0" class="text-block text-block--small text-block--info col-12">{{ $t('pageFindReservation.infoResults', { results: rows.length }) }}</span>
      </hm-card-inner>
      <hm-card-inner v-if="rows.length === 0">
        <h1 class="col-12">{{ $t('pageFindReservation.search.noResults') }}</h1>
      </hm-card-inner>
      <hm-card-inner v-if="rows.length > 0" :full-size="true">
        <paginated-table :items-per-page="25"
                         :rows="filteredRows"
                         :sticky="true"
                         min-width="600px"
                         columns="11 5@mobile">
          <template slot="table-head">
            <sortable-th :number="true" field="reservationNumber">{{ $t('pageFindReservation.search.reservationNumber') }}</sortable-th>
            <div class="hm-table__th">{{ $t('pageFindReservation.search.name') }}</div>
            <sortable-th field="checkInDate">{{ $t('pageFindReservation.search.arrivalDate') }}</sortable-th>
            <sortable-th field="checkOutDate">{{ $t('pageFindReservation.search.departureDate') }}</sortable-th>
            <div class="hm-table__th hidden@mobile">{{ $t('pageFindReservation.search.numAdults') }}</div>
            <div class="hm-table__th hidden@mobile">{{ $t('pageFindReservation.search.numChildren') }}</div>
            <div class="hm-table__th hidden@mobile">{{ $t('pageFindReservation.search.confirmationNumber') }}</div>
            <div class="hm-table__th hidden@mobile">{{ $t('pageFindReservation.search.sourceName') }}</div>
            <sortable-th field="type" class="hidden@mobile">{{ $t('pageFindReservation.search.reservationType') }}</sortable-th>
            <sortable-th field="status" class="hidden@mobile">{{ $t('pageFindReservation.search.status') }}</sortable-th>
            <sortable-th field="roomNumber">{{ $t('pageFindReservation.search.roomNumber') }}</sortable-th>
          </template>
          <template v-slot:default="slotProps">
            <template v-for="row in slotProps.currentPage">
              <div class="hm-table__td" @click="openReservation(row.id)">{{ row.reservationNumber }}</div>
              <div :title="row.displayName" class="hm-table__td privacy--blur" @click="openReservation(row.id)">{{ isEmpty(row.shortInternalComment) ? '' : `[${row.shortInternalComment}] ` }}{{ row.displayName }}</div>
              <div class="hm-table__td" @click="openReservation(row.id)">{{ row.checkInDate | moment($moment.localeData().longDateFormat('L')) }}</div>
              <div class="hm-table__td" @click="openReservation(row.id)">{{ row.checkOutDate | moment($moment.localeData().longDateFormat('L')) }}</div>
              <div class="hm-table__td hidden@mobile" @click="openReservation(row.id)">{{ row.numAdults }}</div>
              <div class="hm-table__td hidden@mobile" @click="openReservation(row.id)">{{ row.numChildren }}</div>
              <div class="hm-table__td hidden@mobile" @click="openReservation(row.id)">{{ row.confirmationNumber }}</div>
              <div class="hm-table__td hidden@mobile" @click="openReservation(row.id)">{{ row.sourceName }}</div>
              <div v-if="row.type !== 'OnRequest'" class="hm-table__td hidden@mobile" @click="openReservation(row.id)">{{ $t(`ReservationType.${row.type}`) }}</div>
              <div v-else-if="today > row.requestExpirationDate" class="hm-table__td hidden@mobile" @click="openReservation(row.id)">{{ $t(`ReservationType.${row.type}`) }}<span class="color--red text--bold hidden visible@desktop visible@hd"> ({{ row.requestExpirationDate | moment($moment.localeData().longDateFormat('L')) }})</span></div>
              <div v-else class="hm-table__td hidden@mobile" @click="openReservation(row.id)">{{ $t(`ReservationType.${row.type}`) }}<span class="hidden visible@desktop visible@hd"> (bis {{ row.requestExpirationDate | moment($moment.localeData().longDateFormat('L')) }})</span></div>
              <div class="hm-table__td hidden@mobile" @click="openReservation(row.id)">{{ $t(`ReservationStatus.${row.status}`) }}</div>
              <div class="hm-table__td" @click="openReservation(row.id)"><template v-if="!isEmpty(row.roomNumber) && row.roomNumber.indexOf('DELETED::') < 0">{{ row.roomNumber }}</template></div>
            </template>
          </template>
        </paginated-table>
      </hm-card-inner>
    </card>
    <card v-if="extendedOptions" :title="$t('pageFindReservation.extendedOptions')" cols="12 4@tablet 3@desktop 2@hd">
      <hm-card-inner :title="$t('pageFindReservation.card.exactSearch')">
        <hm-input v-model="confirmationNumber"
                  :label="$t('pageRoomReservation.confirmationNumber')"
                  name="confirmationNumber"
                  cols="12" />
        <hm-input v-model="externalReservationNumber"
                  :label="$t('pageFindReservation.externalReservationNumber')"
                  :help="$t('pageFindReservation.externalReservationNumber_help')"
                  name="externalReservationNumber"
                  cols="12" />
      </hm-card-inner>
      <hm-card-inner :title="$t('pageFindReservation.card.exactSearch')">
        <hm-input-select v-model="reservationSourceName"
                         :label="$t('pageRoomReservation.reservationSourceName')"
                         name="reservationSourceName"
                         cols="12">
          <option :value="null"></option>
          <template v-if="!isNil(sourceNames)">
            <option v-for="sourceName in sourceNames" :value="sourceName" :key="sourceName">{{ sourceName }}</option>
          </template>
        </hm-input-select>
        <hm-input v-model="reservationNumber"
                  :label="$t('pageFindReservation.reservationNumber')"
                  name="reservationNumber"
                  cols="12" />
        <hm-input-money v-model="prepaymentAmount"
                        :label="$t('pageRoomReservation.prepaymentAmount')"
                        :currency="hotelSettings.details.currency"
                        :required="false"
                        name="prepaymentAmount"
                        cols="12">
          <template slot="icon-inline-left" slot-scope="slot">
            <input-icon-button :border="false"
                               :is-slot="false"
                               icon="equals" />
          </template>
        </hm-input-money>
        <hm-input-date v-model="requestExpirationDate"
                       :label="$t('pageRoomReservation.requestExpirationDate')"
                       :required="false"
                       name="requestExpirationDate"
                       cols="12">
          <template slot="icon-inline-left" slot-scope="slot">
            <input-icon-button :border="false"
                               :is-slot="false"
                               icon="less" />
          </template>
        </hm-input-date>
      </hm-card-inner>
    </card>
    <hm-floating-buttons>
      <hm-floating-button :label="$t('pageFindReservation.actions.createReservation')" icon="plus" color="blue" @click="addReservation" />
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import {
  isArray,
  join,
  isNil,
  isEmpty,
  get,
  filter,
  last,
  find,
  nth,
  template,
  clone,
  cloneDeep,
  isEqual,
  isObject,
  debounce,
  lowerCase,
  sortBy,
  isNumber,
  isNaN,
} from 'lodash';
import HmCol from '../lib/layout/HmCol';
import HmTable from '../lib/table/HmTable';
import { util } from 'protobufjs/minimal';
import HmCardInner from '../lib/layout/HmCardInner';
import PageMixin from '../../mixins/PageMixin';

export default {
  name: 'PageFindReservation',
  components: { HmCardInner, HmCol, HmTable },

  mixins: [HotelmeisterMixin, PageMixin],
  props: ['test'],

  data() {
    return {
      search: {
        name: null,
        startDate: null,
        endDate: null,
        status: null,
        limit: 100,
        excludeOnRequest: true,
      },
      lastSearch: null,
      lastExtendedSearchQuery: null,
      filter: null,
      rows: [],
      debouncedUpdateSearch: null,
      // flags
      arrivalsOnly: false,
      departuresOnly: false,
      onRequestOnly: false,
      allReservations: false,
      extendedOptions: false,
      // additional search criteria
      prepaymentAmount: null,
      confirmationNumber: null,
      reservationSourceName: null,
      reservationNumber: null,
      requestExpirationDate: null,
      externalReservationNumber: null,
      sourceName: null,
      // others
      today: this.$moment().format('YYYYMMDD'),
    };
  },

  computed: {
    breakpoint: function () {
      return this.$store.getters['layout/activeBreakpoint'];
    },
    maxHotelDate: function () {
      return this.$moment().add(this.hotelSettings.details.futureDates, 'days').format('YYYYMMDD');
    },
    filteredRows: function () {
      let ret = this.rows;

      if (!isEmpty(this.filter)) {
        ret = ret.filter(it => Object.values(it).filter(str => !isEmpty(str) && lowerCase(str).indexOf(lowerCase(this.filter)) >= 0).length > 0);
      }

      const startDate = this.$moment(this.search.startDate, 'YYYYMMDD');
      const endDate = this.$moment(this.search.endDate, 'YYYYMMDD');

      if (this.arrivalsOnly) {
        ret = ret.filter(it => !this.$moment(it.checkInDate, 'YYYYMMDD').isBefore(startDate) && !this.$moment(it.checkInDate, 'YYYYMMDD').isAfter(endDate));
      }

      if (this.departuresOnly) {
        ret = ret.filter(it => !this.$moment(it.checkOutDate, 'YYYYMMDD').isBefore(startDate) && !this.$moment(it.checkOutDate, 'YYYYMMDD').isAfter(endDate));
      }

      if (this.onRequestOnly) {
        ret = ret.filter(it => it.type === 'OnRequest');
      }

      if (isEmpty(this.search.name)) {
        ret = sortBy(ret, ['checkInDate', 'roomNumber']);
      }

      return ret;
    },
    pageShortcuts: function () {
      return {
        'Ctrl+←': this.$t('pageFindReservation.shortcuts.back1d'),
        'Ctrl+→': this.$t('pageFindReservation.shortcuts.forward1d'),
        'Alt+0': this.$tc('pageFindReservation.shortcuts.searchPeriodPlusXd', 0, { idx: 0 }),
        'Alt+1': this.$tc('pageFindReservation.shortcuts.searchPeriodPlusXd', 1, { idx: 1 }),
        'Alt+2': this.$tc('pageFindReservation.shortcuts.searchPeriodPlusXd', 2, { idx: 2 }),
        'Alt+3': this.$tc('pageFindReservation.shortcuts.searchPeriodPlusXd', 3, { idx: 3 }),
        'Alt+4': this.$tc('pageFindReservation.shortcuts.searchPeriodPlusXd', 4, { idx: 4 }),
        'Alt+5': this.$tc('pageFindReservation.shortcuts.searchPeriodPlusXd', 5, { idx: 5 }),
        'Alt+6': this.$tc('pageFindReservation.shortcuts.searchPeriodPlusXd', 6, { idx: 6 }),
        'Alt+7': this.$tc('pageFindReservation.shortcuts.searchPeriodPlusXd', 7, { idx: 7 }),
        'Alt+8': this.$tc('pageFindReservation.shortcuts.searchPeriodPlusXd', 8, { idx: 8 }),
        'Alt+9': this.$tc('pageFindReservation.shortcuts.searchPeriodPlusXd', 9, { idx: 9 }),
      };
    },
  },

  watch: {
    breakpoint: function (newValue) {
      switch (newValue) {
        case 'desktop':
        case 'hd':
          break;
        default:
          if (this.extendedOptions) this.extendedOptions = false;
          break;
      }
    },
    allReservations: function (newValue) {
      if (newValue) {
        this.search.startDate = '20150101';
        this.search.status = null;
        this.search.excludeOnRequest = false;
        this.arrivalsOnly = false;
        this.departuresOnly = false;
        this.onRequestOnly = false;
        this.extendedOptions = true;
        this.$nextTick(() => {
          this.search.endDate = '20991231';
          this.onChangeInput();
        });
      } else {
        this.search.startDate = this.$moment().add(-2, 'days').format('YYYYMMDD');
        this.search.limit = 100;
        this.$nextTick(() => {
          this.search.endDate = this.$moment().add(3, 'days').format('YYYYMMDD');
          this.onChangeInput();
        });
      }
    },
    extendedOptions: function () {
      this.onChangeInput();
    },
    prepaymentAmount: function () {
      this.onChangeInput();
    },
    confirmationNumber: function () {
      this.onChangeInput();
    },
    reservationSourceName: function () {
      this.onChangeInput();
    },
    reservationNumber: function () {
      this.onChangeInput();
    },
    requestExpirationDate: function () {
      this.onChangeInput();
    },
    externalReservationNumber: function () {
      this.onChangeInput();
    },
    'search.name': function () {
      this.onChangeInput();
    },
    'search.startDate': function () {
      this.onChangeInput();
    },
    'search.endDate': function () {
      this.onChangeInput();
    },
    'search.status': function () {
      this.onChangeInput();
    },
    'search.limit': function () {
      this.onChangeInput();
    },
    'search.excludeOnRequest': function () {
      this.onChangeInput();
    },
    arrivalsOnly: function (newVal) {
      if (newVal) this.departuresOnly = false;
    },
    departuresOnly: function (newVal) {
      if (newVal) this.arrivalsOnly = false;
    },
  },

  created: function () {
    this.init();
    this.debouncedUpdateSearch = debounce(this.updateSearch, 250);
    this.search.name = !isEmpty(this.$route.query.q) ? this.$route.query.q : '';
    this.search.limit = !isNil(this.$route.query.limit) ? Math.max(this.$route.query.limit, 100) : 100;
    this.search.excludeOnRequest = this.$route.query.excludeOnRequest === true;
    this.search.startDate = !isNil(this.$route.query.startDate)
      ? this.$route.query.startDate
      : this.$moment().add(-2, 'days').format('YYYYMMDD');
    this.search.endDate = !isNil(this.$route.query.endDate)
      ? this.$route.query.endDate
      : this.$moment().add(3, 'days').format('YYYYMMDD');

    this.$serviceBus.$on('shortcut.pageRight', this.add1Day);
    this.$serviceBus.$on('shortcut.pageLeft', this.subtract1Day);
    this.$serviceBus.$on('shortcut.count', this.setDays);

    if (!isNil(this.$route.params) && !isEmpty(this.$route.params.status)) {
      this.search.status = this.$route.params.status;
    }

    if (!isNil(this.$route.params) && !isNil(this.$route.params.onRequestOnly)) {
      this.onRequestOnly = this.$route.params.onRequestOnly;
    }

    if (!isNil(this.$route.params) && !isNil(this.$route.params.arrivalsOnly)) {
      this.arrivalsOnly = this.$route.params.arrivalsOnly;
    }

    if (!isNil(this.$route.params) && !isNil(this.$route.params.departuresOnly)) {
      this.departuresOnly = this.$route.params.departuresOnly;
    }
  },

  beforeDestroy: function () {
    this.$serviceBus.$off('shortcut.pageRight', this.add1Day);
    this.$serviceBus.$off('shortcut.pageLeft', this.subtract1Day);
    this.$serviceBus.$off('shortcut.count', this.setDays);
  },

  methods: {
    init() {
      this.axios.get(this.serviceUrls.reservation.sourceName(this))
        .then((response) => {
          this.sourceNames = response.data.data;
        });
    },
    setDays(dayCount) {
      this.search.endDate = this.$moment(this.search.startDate, 'YYYYMMDD').add(dayCount, 'days').format('YYYYMMDD');
    },
    add1Day() {
      if (!isNil(this.$refs) && !isNil(this.$refs.startDate) && !this.$refs.startDate.hasFocus && !isNil(this.$refs.endDate) && !this.$refs.endDate.hasFocus) {
        this.search.startDate = this.$moment(this.search.startDate, 'YYYYMMDD').add(1, 'days').format('YYYYMMDD');
      }
    },
    subtract1Day() {
      if (!isNil(this.$refs) && !isNil(this.$refs.startDate) && !this.$refs.startDate.hasFocus && !isNil(this.$refs.endDate) && !this.$refs.endDate.hasFocus) {
        this.search.startDate = this.$moment(this.search.startDate, 'YYYYMMDD').add(-1, 'days').format('YYYYMMDD');
      }
    },
    openReservation: function (reservationId) {
      this.$router.push({ name: 'reservation', params: { reservationId: reservationId } });
    },
    addReservation: function () {
      this.$router.push({ name: 'createReservation' });
    },
    onClickSearch: function () {
      this.updateSearch();
    },
    onChangeInput: function () {
      if (!isNil(this.debouncedUpdateSearch)) {
        this.debouncedUpdateSearch();
        this.filter = null;
      }
    },
    updateSearch: function () {
      const currentSearch = cloneDeep(this.search);

      let extendedSearchQuery = '';

      if (this.extendedOptions) {
        if (isNumber(this.prepaymentAmount) && !isNaN(this.prepaymentAmount)) {
          extendedSearchQuery += ` +prepayment.prepaymentAmount:${this.prepaymentAmount.toFixed(2)}`;
        }

        if (!isEmpty(this.confirmationNumber)) {
          extendedSearchQuery += ` +confirmationNumber:*${this.confirmationNumber.toLocaleUpperCase()}*`;
        }

        if (!isEmpty(this.reservationSourceName)) {
          extendedSearchQuery += ` +sourceInfo.sourceName:*${this.reservationSourceName.toLocaleLowerCase()}*`;
        }

        if (!isEmpty(this.reservationNumber)) {
          extendedSearchQuery += ` +reservationNumber:${this.reservationNumber}`;
        }

        if (!isEmpty(this.requestExpirationDate)) {
          extendedSearchQuery += ` +type:OnRequest -status:RequestExpired -status:Cancelled -status:CreationFailed -status:NoShow +requestExpirationDate:<"${this.$moment(this.requestExpirationDate, 'YYYYMMDD').format('YYYY-MM-DD')}"`;
        }

        if (!isEmpty(this.externalReservationNumber)) {
          extendedSearchQuery += ` +externalReservationNumbers.value:*${this.externalReservationNumber.toLocaleLowerCase()}*`;
        }
      }

      extendedSearchQuery = extendedSearchQuery.trim();

      if ((isEmpty(currentSearch.name) || currentSearch.name.length < 2) && isNil(currentSearch.startDate) && isNil(currentSearch.endDate)) {
        this.rows = [];
        this.lastSearch = null;
        this.lastExtendedSearchQuery = null;
        return;
      }

      if (isEqual(currentSearch, this.lastSearch) && isEqual(extendedSearchQuery, this.lastExtendedSearchQuery)) {
        return;
      }

      this.axios.get(this.serviceUrl('reservation.find'), {
        params: {
          q: currentSearch.name,
          extendedSearchQuery: extendedSearchQuery,
          from: isNil(currentSearch.startDate) ? '' : currentSearch.startDate,
          until: isNil(currentSearch.endDate) ? '' : currentSearch.endDate,
          all: this.allReservations,
          status: currentSearch.status,
          limit: currentSearch.limit,
          excludeOnRequest: currentSearch.excludeOnRequest,
        },
      })
        .then((response) => {
          this.rows = response.data.data;
          this.rows.forEach((it) => {
            it.statusText = this.$t(`ReservationStatus.${it.status}`);
            it.typeText = this.$t(`ReservationType.${it.type}`);
            it.checkInDateText = this.$options.filters.toDate(it.checkInDate);
            it.checkOutDateText = this.$options.filters.toDate(it.checkOutDate);
          });

          if (isEmpty(currentSearch.name) && isEmpty(extendedSearchQuery)) {
            this.rows = sortBy(this.rows, ['checkInDate', 'roomNumber']);
          }

          this.lastSearch = currentSearch;
          this.lastExtendedSearchQuery = extendedSearchQuery;
        });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/import';

  .hm-table__td {
    cursor: pointer;
  }
</style>

<style lang="scss">
  @import '~styles/import';

</style>



// WEBPACK FOOTER //
// src/components/pages/PageFindReservation.vue